import type { Epic } from '@helpcenter/epics-rxjs';
import { Observable } from '@helpcenter/epics-rxjs';
import fetchModel from 'epics/model/fetcher';
import type { UpdateReqSlasModelAction } from 'state/actions/req-slas';
import { updateReqSlasModelAction } from 'state/actions/req-slas';
import type { FetchReqSlasModelAction } from './actions';
import { FETCH_REQ_SLAS_MODEL } from './actions';

export const reqSlasEpic: Epic<FetchReqSlasModelAction, UpdateReqSlasModelAction> = (action$) => {
	return action$.ofType(FETCH_REQ_SLAS_MODEL).mergeMap((action) =>
		fetchModel(action.payload)
			.filter((response) => response.reqSlas !== undefined)
			.map((response) => updateReqSlasModelAction(action.payload.params.key, response.reqSlas!))
			.catch(() => Observable.never() as Observable<UpdateReqSlasModelAction>),
	);
};
